/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface SharePlaylistResponse
 */
export interface SharePlaylistResponse {
  /**
   * Confirmation message indicating the request was received.
   * @type string
   * @memberof SharePlaylistResponse
   */
  message: string
  /**
   * The processing status of the request.
   * @type string
   * @memberof SharePlaylistResponse
   */
  status: string
}

export function SharePlaylistResponseFromJSON(
  json: any
): SharePlaylistResponse {
  return SharePlaylistResponseFromJSONTyped(json, false)
}

export function SharePlaylistResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharePlaylistResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    message: json['message'],
    status: json['status'],
  }
}

export function SharePlaylistResponseToJSON(
  value?: SharePlaylistResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    message: value.message,
    status: value.status,
  }
}
